import * as React from 'react'
import { Link as RouterLink } from "react-router-dom"
import { Link } from "@mui/material"

import { MARKETPLACES_ROUTES } from "@constants"
import { country, seller, retailer, commonFiltersShareValue, encodeCommonFiltersShareValue } from "@signals"


export default function sellerColumn() {
	return {
		name: 'sellerName', label: 'Seller',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, dataRow) => {
				const specificFilters = {
                    country: dataRow?.country ? [dataRow.country] : country.peek(),
					retailer: dataRow?.retailerID ? [dataRow.retailerID] : [],
                    sellers: dataRow?.sellerID ? [dataRow.sellerID] : []
                }
                const url = `${MARKETPLACES_ROUTES.SELLER_DEEP_DIVE_PATH}?sp=${encodeCommonFiltersShareValue({...commonFiltersShareValue.peek(), ...specificFilters})}`
                
				const handleClick = () => {
					country.value = [dataRow.country]
					retailer.value = [dataRow.retailerID]
					seller.value = [dataRow.sellerID]
				}

				return <Link
					component={RouterLink}
					to={url}
					onClick={handleClick}
				>
					{value}
				</Link>
			}
		}
	}
}